import React, { useState, useEffect, useRef } from "react";
import { SparklesIcon, GiftIcon, HeartIcon, TrendingUpIcon, CalendarIcon, QrCodeIcon, XIcon, CheckCircleIcon, ChevronDownIcon, BoxIcon } from "lucide-react";
import JsBarcode from "jsbarcode";
import { motion, AnimatePresence } from "framer-motion";
export function LoyaltyPointsSection() {
  const [currentPoints, setCurrentPoints] = useState(2450);
  const tierProgress = 65;
  const nextTierPoints = 3000;
  const [selectedCategory, setSelectedCategory] = useState<'all' | 'theqh' | 'donations'>('all');
  const [isCategorySheetOpen, setIsCategorySheetOpen] = useState(false);
  const barcodeRef = useRef<SVGSVGElement>(null);
  const memberId = '1234567890';
  const [selectedCoupon, setSelectedCoupon] = useState<{
    id: number;
    value: number;
    points: number;
  } | null>(null);
  const [purchaseStatus, setPurchaseStatus] = useState<'idle' | 'confirming' | 'success'>('idle');
  const [generatedCode, setGeneratedCode] = useState('');
  useEffect(() => {
    if (barcodeRef.current) {
      try {
        JsBarcode(barcodeRef.current, memberId, {
          format: 'CODE128',
          width: 2.5,
          height: 60,
          displayValue: false,
          background: '#ffffff',
          lineColor: '#000000',
          margin: 10
        });
      } catch (error) {
        console.error('Error generating barcode:', error);
      }
    }
  }, []);
  const categoryOptions = [{
    id: 'all' as const,
    label: 'All coupons',
    icon: BoxIcon
  }, {
    id: 'theqh' as const,
    label: 'Theqh Gifts',
    icon: GiftIcon
  }, {
    id: 'donations' as const,
    label: 'Donations',
    icon: HeartIcon
  }];
  const selectedCategoryLabel = categoryOptions.find(category => category.id === selectedCategory)?.label ?? 'All coupons';
  const coupons = [{
    id: 1,
    value: 10,
    points: 900,
    color: 'from-blue-500 to-blue-700'
  }, {
    id: 2,
    value: 15,
    points: 1200,
    color: 'from-blue-600 to-blue-800'
  }, {
    id: 3,
    value: 25,
    points: 1875,
    color: 'from-gray-400 to-gray-600'
  }, {
    id: 4,
    value: 60,
    points: 3900,
    color: 'from-gray-500 to-gray-700'
  }];
  const pointsHistory = [{
    id: 1,
    description: 'Purchase - Order #000013951',
    points: 26,
    date: '2024-01-15',
    type: 'earned'
  }, {
    id: 2,
    description: 'Purchase - Order #000013950',
    points: 25,
    date: '2024-01-10',
    type: 'earned'
  }, {
    id: 3,
    description: 'Birthday Bonus',
    points: 100,
    date: '2024-01-05',
    type: 'bonus'
  }, {
    id: 4,
    description: 'Redeemed - 10% Discount Voucher',
    points: -500,
    date: '2024-01-03',
    type: 'redeemed'
  }];
  const handleBuyClick = (coupon: {
    id: number;
    value: number;
    points: number;
  }) => {
    setSelectedCoupon(coupon);
    setPurchaseStatus('confirming');
  };
  const confirmPurchase = () => {
    if (selectedCoupon && currentPoints >= selectedCoupon.points) {
      setCurrentPoints(prev => prev - selectedCoupon.points);
      setGeneratedCode(`RABEH${Math.floor(Math.random() * 10000)}`);
      setPurchaseStatus('success');
    }
  };
  const closePurchaseModal = () => {
    setPurchaseStatus('idle');
    setSelectedCoupon(null);
    setGeneratedCode('');
  };
  return <div className="space-y-6" data-id="element-521" data-mp="3vp81h82bpfoy">
      {/* Points Balance Card */}
      <div className="bg-gradient-to-br from-[#1E2B55] to-[#3a4f94] rounded-2xl shadow-lg p-6 text-white relative overflow-hidden" data-id="element-522" data-mp="3vog69ycn1jz7">
        <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-bl-full pointer-events-none" data-id="element-523" data-mp="33xs90xe34yqt"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/5 rounded-tr-full pointer-events-none" data-id="element-524" data-mp="37z5gtd0qnc0d"></div>
        
        <div className="flex items-start justify-between mb-6 relative z-10" data-id="element-525" data-mp="3czt2dj6770n7">
          <div data-id="element-526" data-mp="n9xvhovbbqbw">
            <p className="text-sm text-blue-100 mb-1" data-id="element-527" data-mp="n8ef7y9npfa4">Hello, Ahmed Gad</p>
            <p className="text-sm text-blue-200 mb-1" data-id="element-528" data-mp="s89827czsext">Your balance</p>
            <p className="text-4xl font-bold" data-id="element-529" data-mp="sac4pa8nh6bi">{currentPoints.toLocaleString()} <span className="text-lg font-normal" data-id="element-530" data-mp="qs542wu974wv">points</span></p>
          </div>
          <div className="bg-white/10 p-2 rounded-xl backdrop-blur-sm border border-white/20" data-id="element-531" data-mp="ltamfy80vmec">
            <QrCodeIcon className="w-12 h-12 text-white" data-id="element-532" data-mp="zsa950bz5r7v" />
          </div>
        </div>

        {/* Barcode Section */}
        <div className="bg-white rounded-xl p-4 relative z-10 text-center" data-id="element-533" data-mp="vpnbgismhc2r">
          <div className="flex items-center justify-center mb-2" data-id="element-534" data-mp="19pg0m9oi3k8m">
            <svg ref={barcodeRef} className="max-w-full h-auto" data-id="element-535" data-mp="14r4pzwqdt5pc"></svg>
          </div>
          <p className="text-sm text-gray-700 font-mono tracking-wider" data-id="element-536" data-mp="14pahjhwar625">
            Member ID: {memberId}
          </p>
        </div>
      </div>

      {/* Buy Coupons */}
      <div data-id="element-537" data-mp="1ehg94qimzlgt">
        <div className="mb-4 flex items-center justify-between" data-id="element-538" data-mp="1ehpws7g7lgjc">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-539" data-mp="1shqyfp4asrzv">Buy Coupons</h3>
          <button type="button" onClick={() => setIsCategorySheetOpen(true)} className="inline-flex h-10 items-center gap-2 rounded-xl border border-gray-200 bg-white px-3 text-sm font-bold text-gray-700 shadow-sm transition-[background-color] duration-150 hover:bg-gray-50" aria-label="Choose coupon category" data-id="element-540" data-mp="1nhw5lg0ypsc6">
            <GiftIcon className="h-4 w-4 text-[#16726c]" data-id="element-541" data-mp="1y3hrl20n2lki" />
            <span data-id="element-542" data-mp="1y52kyob7vygs">{selectedCategoryLabel}</span>
            <ChevronDownIcon className="h-4 w-4 text-gray-400" data-id="element-543" data-mp="223a41pt5lbv5" />
          </button>
        </div>

        <div className="grid grid-cols-2 gap-3" data-id="element-544" data-mp="1obvjvfnif4mi">
          {coupons.map(coupon => <div key={coupon.id} className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden flex flex-col" data-id="element-545" data-mp="1t3dab9rwpmt8">
              <div className={`bg-gradient-to-br ${coupon.color} p-6 flex flex-col items-center justify-center text-white relative h-32`} data-id="element-546" data-mp="1efs5nbfdvfj7">
                <div className="absolute inset-0 opacity-20 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PHBhdGggZD0iTTAgMGgyMHYyMEgwem0xMCAxMGgxMHYxMEgxMHoiIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iLjEiLz48L3N2Zz4=')]" data-id="element-547" data-mp="1jbr3rqqikbwt"></div>
                <div className="absolute top-2 left-2 bg-white/90 px-1.5 py-0.5 rounded text-[8px] font-bold text-[#1E2B55] flex items-center gap-1" data-id="element-548" data-mp="3c4e5n3wsrnzy">
                  <GiftIcon className="w-2.5 h-2.5" data-id="element-549" data-mp="32bqbkgx7by4x" /> Theqh
                </div>
                <span className="text-5xl font-light relative z-10 tracking-tighter" data-id="element-550" data-mp="2yb6f7fkgcyju">
                  <span className="text-lg font-bold mr-1" data-id="element-551" data-mp="3v16y4xy54kt8">SAR</span>{coupon.value}
                </span>
              </div>
              <div className="p-3 text-center bg-white flex flex-col items-center justify-center flex-grow" data-id="element-552" data-mp="3q1kiyiyr4uhs">
                <p className="text-sm font-bold text-gray-900 mb-2" data-id="element-553" data-mp="3lzpjlk0dsr6n">{coupon.points} Points</p>
                <button onClick={() => handleBuyClick(coupon)} disabled={currentPoints < coupon.points} className={`w-full py-2 rounded-lg text-xs font-bold transition-colors ${currentPoints >= coupon.points ? 'bg-[#1E2B55] text-white hover:bg-[#162041]' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`} data-id="element-554" data-mp="3h2793p6pu3wj">
                  {currentPoints >= coupon.points ? 'Buy Coupon' : 'Earn points to buy'}
                </button>
              </div>
            </div>)}
        </div>
      </div>

      {/* Points History */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-555" data-mp="u3ts1xjllmtn">
        <div className="p-5 border-b border-gray-200" data-id="element-556" data-mp="yw4vvbhglsrh">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-557" data-mp="yxpnas8h8vl4">Points History</h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-558" data-mp="13ug4xjzxjz8n">
          {pointsHistory.map(item => <div key={item.id} className="p-5 hover:bg-gray-50 transition-colors" data-id="element-559" data-mp="18shk3tu8jeeu">
              <div className="flex items-center justify-between" data-id="element-560" data-mp="1dsm0ljv58952">
                <div className="flex items-center gap-3" data-id="element-561" data-mp="1huh14m592ihs">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center ${item.type === 'redeemed' ? 'bg-red-100' : 'bg-green-100'}`} data-id="element-562" data-mp="1htxmpfet6c8i">
                    {item.type === 'bonus' ? <GiftIcon className="w-5 h-5 text-purple-600" data-id="element-563" data-mp="3jmvm5u33c32f" /> : item.type === 'redeemed' ? <SparklesIcon className="w-5 h-5 text-red-600" data-id="element-564" data-mp="30p20wzad1rvn" /> : <TrendingUpIcon className="w-5 h-5 text-green-600" data-id="element-565" data-mp="30nqwqyd06i40" />}
                  </div>
                  <div data-id="element-566" data-mp="2vq8qjfqdegzp">
                    <p className="font-medium text-gray-900" data-id="element-567" data-mp="39hvwy8e115w7">
                      {item.description}
                    </p>
                    <p className="text-sm text-gray-600 flex items-center gap-1" data-id="element-568" data-mp="35g1ze8z4oi09">
                      <CalendarIcon className="w-3 h-3" data-id="element-569" data-mp="2hqfztkeug0rq" />
                      {item.date}
                    </p>
                  </div>
                </div>
                <p className={`font-bold ${item.points > 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-570" data-mp="2cth796atw1vn">
                  {item.points > 0 ? '+' : ''}
                  {item.points}
                </p>
              </div>
            </div>)}
        </div>
      </div>

      <AnimatePresence data-id="element-571" data-mp="60dp40y97yvs">
        {isCategorySheetOpen && <>
          <motion.button type="button" aria-label="Close coupon category picker" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setIsCategorySheetOpen(false)} className="fixed inset-0 z-[100] bg-black/45" data-id="element-572" data-mp="62zym64pgogn" />
          <motion.section role="dialog" aria-modal="true" aria-labelledby="coupon-category-title" initial={{
          y: '100%'
        }} animate={{
          y: 0
        }} exit={{
          y: '100%'
        }} transition={{
          type: 'spring',
          damping: 28,
          stiffness: 280
        }} className="fixed inset-x-0 bottom-0 z-[101] rounded-t-3xl bg-white p-5 pb-[calc(1.25rem+env(safe-area-inset-bottom))] shadow-2xl" data-id="element-573" data-mp="did1z9fk2xgb">
            <div className="mx-auto mb-5 h-1.5 w-10 rounded-full bg-gray-200" data-id="element-574" data-mp="iirb6usw8dfx" />
            <div className="mb-4 flex items-center justify-between" data-id="element-575" data-mp="nicax7fw0ptp"><h3 id="coupon-category-title" className="text-lg font-bold text-gray-900" data-id="element-576" data-mp="ngsp71bgpmkj">Coupon category</h3><button type="button" onClick={() => setIsCategorySheetOpen(false)} className="rounded-full p-2 text-gray-500 hover:bg-gray-100" aria-label="Close" data-id="element-577" data-mp="1b7544w54kjkm"><XIcon className="h-5 w-5" data-id="element-578" data-mp="2svvo2133vahp" /></button></div>
            <div className="space-y-2" data-id="element-579" data-mp="2suaoty5uj3di">{categoryOptions.map(category => {
              const Icon = category.icon;
              const isSelected = selectedCategory === category.id;
              return <button key={category.id} type="button" onClick={() => {
                setSelectedCategory(category.id);
                setIsCategorySheetOpen(false);
              }} className={`flex w-full items-center gap-3 rounded-xl border p-4 text-left transition-[background-color,border-color] duration-150 ${isSelected ? 'border-[#16726c] bg-emerald-50' : 'border-gray-200 bg-white hover:bg-gray-50'}`} data-id="element-580" data-mp="2jvfmix5xadfh"><span className={`flex h-10 w-10 items-center justify-center rounded-xl ${isSelected ? 'bg-[#16726c] text-white' : 'bg-gray-100 text-gray-600'}`} data-id="element-581" data-mp="217269yx21p60"><Icon className="h-5 w-5" data-id="element-582" data-mp="1r6i2aoi5i6k3" /></span><span className="flex-1 text-sm font-bold text-gray-900" data-id="element-583" data-mp="1r8cnm3xc40op">{category.label}</span>{isSelected && <CheckCircleIcon className="h-5 w-5 text-[#16726c]" data-id="element-584" data-mp="1w4tc4z8g4h2b" />}</button>;
            })}</div>
          </motion.section>
        </>}
      </AnimatePresence>

      {/* Purchase Modal */}
      <AnimatePresence data-id="element-585" data-mp="17mb5jtj8v2lj">
        {purchaseStatus !== 'idle' && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={closePurchaseModal} className="fixed inset-0 bg-black/50 z-[100]" data-id="element-586" data-mp="1mi8xezm4xkry" />
            <motion.div initial={{
          y: '100%'
        }} animate={{
          y: 0
        }} exit={{
          y: '100%'
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 200
        }} className="fixed bottom-0 left-0 right-0 bg-white rounded-t-3xl z-[101] p-6 pb-safe" data-id="element-587" data-mp="1vi5eog673hcz">
              <div className="flex items-center justify-between mb-6" data-id="element-588" data-mp="20afa2bq2x9mn">
                <h3 className="text-xl font-bold text-gray-900" data-id="element-589" data-mp="2eaq5ls2c3ce5">
                  {purchaseStatus === 'confirming' ? 'Confirm Purchase' : 'Purchase Successful'}
                </h3>
                <button onClick={closePurchaseModal} className="p-2 text-gray-400 hover:text-gray-600" data-id="element-590" data-mp="2hbt7vevvpzuw">
                  <XIcon className="w-6 h-6" data-id="element-591" data-mp="2m9l1qeg33w1q" />
                </button>
              </div>

              {purchaseStatus === 'confirming' ? <div className="space-y-6" data-id="element-592" data-mp="2r8pbp7au1xt4">
                  <div className="bg-gray-50 rounded-xl p-4 text-center" data-id="element-593" data-mp="2w07bhs14dsci">
                    <p className="text-gray-600 mb-2" data-id="element-594" data-mp="2w2aa30gc8tsu">You are about to buy a</p>
                    <p className="text-3xl font-bold text-[#1E2B55] mb-2" data-id="element-595" data-mp="3019b49yy86f0">{selectedCoupon?.value} SAR Coupon</p>
                    <p className="text-sm font-medium text-gray-500" data-id="element-596" data-mp="34z14l8f8s0lb">for {selectedCoupon?.points} Points</p>
                  </div>
                  <div className="flex gap-3" data-id="element-597" data-mp="3ez1n4s5aecog">
                    <button onClick={closePurchaseModal} className="flex-1 py-3.5 rounded-xl font-bold text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors" data-id="element-598" data-mp="3exqot7um1x4q">
                      Cancel
                    </button>
                    <button onClick={confirmPurchase} className="flex-1 py-3.5 rounded-xl font-bold text-white bg-[#1E2B55] hover:bg-[#162041] transition-colors" data-id="element-599" data-mp="1kn4uivv3z0rt">
                      Confirm
                    </button>
                  </div>
                </div> : <div className="space-y-6 text-center" data-id="element-600" data-mp="3p2733wsfz66f">
                  <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-601" data-mp="3p0m5tzeqt94v">
                    <CheckCircleIcon className="w-10 h-10 text-green-600" data-id="element-602" data-mp="koicq6pco979" />
                  </div>
                  <div data-id="element-603" data-mp="gngadh04zh12">
                    <p className="text-gray-600 mb-2" data-id="element-604" data-mp="gmwzulctfux2">Your new coupon code is ready!</p>
                    <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 flex items-center justify-center gap-3" data-id="element-605" data-mp="bnkek51levwl">
                      <span className="text-2xl font-mono font-bold tracking-widest text-[#1E2B55]" data-id="element-606" data-mp="6o7kaz8e6mjz">{generatedCode}</span>
                    </div>
                    <p className="text-xs text-gray-400 mt-3" data-id="element-607" data-mp="2rf8259upvc2q">This code has been saved to your coupons list.</p>
                  </div>
                  <button onClick={closePurchaseModal} className="w-full py-3.5 rounded-xl font-bold text-white bg-[#1E2B55] hover:bg-[#162041] transition-colors" data-id="element-608" data-mp="j5h0ic0ii6kq">
                    Done
                  </button>
                </div>}
            </motion.div>
          </>}
      </AnimatePresence>
    </div>;
}